import { TextField, MenuItem, FormLabel } from "@mui/material";

import { ChangeEvent } from "react";

import { DEFAULT } from "@/constants";
import { User } from "@/pages/Public/pages/Login/schema/login";

import { translateError, ERROR_TYPE } from "@/utils";

import { UserRole } from "../../UserRoles/schema/roles";

interface FormSelectRoleProps {
	user: User | null;
	isEnoughPermissionForChangingRole: boolean;
	selectedUser: User | null;
	roles: UserRole[];
	handleUserRoleChange: (event: ChangeEvent<{ value: unknown }>) => void;
	label?: string;
	errorMessage?: string;
	required?: boolean;
	showLabel?: boolean;
}

export default function FormSelectRole({
	user,
	isEnoughPermissionForChangingRole,
	selectedUser,
	roles,
	handleUserRoleChange,
	errorMessage,
	label,
	required = true,
	showLabel = true,
}: FormSelectRoleProps) {
	return (
		<div className={`space-y-1 mb-4 w-full relative`}>
			{showLabel && (
				<FormLabel
					component="label"
					sx={{
						color: "#1D243C",
						fontSize: "14px",
						fontWeight: "500",
					}}
				>
					{label} {!!required && <span className="text-red-500">*</span>}
				</FormLabel>
			)}
			<TextField
				select
				SelectProps={{
					MenuProps: {
						PaperProps: {
							sx: {
								padding: "8px",
								width: "140px",
								marginTop: "4px",
								borderRadius: "12px",
								"& .MuiList-root": {
									margin: "0px",
									padding: "0px",
									gap: "8px",
									display: "flex",
									flexDirection: "column",
								},
								"& .MuiMenuItem-root": {
									display: "flex",
									alignItems: "center",
									justifyContent: "space-between",
									fontSize: "14px",
									margin: "0px",
									padding: "0px",
									backgroundColor: "transparent !important",
									"&.Mui-selected": {
										color: "#4680FC",
									},
									"&:hover": {
										backgroundColor: "transparent !important",
									},
								},
							},
						},
					},
				}}
				disabled={!isEnoughPermissionForChangingRole}
				inputProps={{
					style: {
						display: "flex",
						alignItems: "center",
						fontSize: "14px",
						fontWeight: "400",
					},
				}}
				sx={{
					width: "100%",
					"& .MuiSelect-select": {
						alignSelf: "flex-end",
						padding: "8px",
						fontSize: "14px",
						fontWeight: "400",
					},
					"& .MuiInputBase-root": {
						marginBottom: "0px",
						borderRadius: "12px",
						fontSize: "14px",
					},
					"& .MuiSelect-icon": {
						color: "#1D243C",
					},
				}}
				value={selectedUser?.role?.id ?? DEFAULT}
				onChange={handleUserRoleChange}
			>
				{isEnoughPermissionForChangingRole ? (
					roles?.map((role) => (
						<MenuItem key={role.id} value={role.id}>
							{role.name}
						</MenuItem>
					))
				) : (
					<MenuItem key={user?.role.id} value={user?.role.id}>
						{user?.role.name}
					</MenuItem>
				)}
			</TextField>
			{errorMessage && (
				<p className="absolute -bottom-5 text-[12px] text-[#FF1034]">
					{translateError[errorMessage as unknown as ERROR_TYPE] ?? errorMessage}
				</p>
			)}
		</div>
	);
}
